import React from 'react';
import cx from 'classnames';
import DatePicker from 'react-datepicker';
import styles from './index.module.scss.js';

const DatePickerInput = ({
  className,
  style,
  label,
  onChange = () => {
  },
  locale = "en",
  placeholder,
  name,
  required,
  smallLabel,
  size = "md",
  errorMsgAbsolute,
  errors,
  fullWidth = false,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className, {
      [styles[size]]: !!size,
      [styles.required]: required,
      [styles.invalid]: !!errors,
      [styles["small-label"]]: smallLabel,
      [styles["full-width"]]: fullWidth
    }),
    style
  },
  /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, label && /* @__PURE__ */ React.createElement("label", { htmlFor: name }, label), /* @__PURE__ */ React.createElement("div", { className: styles["input-wrapper"] }, /* @__PURE__ */ React.createElement(
    DatePicker,
    {
      ...props,
      placeholderText: placeholder,
      locale,
      showYearDropdown: true,
      peekNextMonth: true,
      showMonthDropdown: true,
      yearDropdownItemNumber: 100,
      onChange,
      name
    }
  ))),
  errors && /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.error, {
        [styles.absolute]: errorMsgAbsolute
      })
    },
    errors.message
  )
);
DatePickerInput.displayName = "DatePickerInput";

export { DatePickerInput };
//# sourceMappingURL=index.js.map
